import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import {
  AdaptiveModalGlobalStyle,
  ButtonClose,
  Footer,
  Header,
  ModalButton,
  StackedBackdropStyle,
  Title,
} from "./style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { PrimaryButton } from "components/Button/style";

interface ModalProps {
  handleClose: () => void;
  show: boolean;
  title?: string | React.ReactNode;
  subTitle?: string;
  children: any;
  size?: "lg" | "sm" | "xl";
  adaptive?: boolean;
  centered?: boolean;
  footer?: boolean;
  footerTools?: any;
  footerButtonOk?: boolean;
  footerConfirmButton?: boolean;
  disabledConfirmButton?: boolean;
  onConfirm?: () => void;
  footerCloseButton?: boolean;
  confirmButtonText?: string;
  ConfirmButtonIcone?: any;
  footerConfirmButtonInvert?: boolean;
  cancelButtonText?: string;
  onCancel?: () => void;
  dialogClassName?: string;
  zIndex?: number;
}

export function ModalCustom({
  handleClose,
  show,
  title,
  subTitle,
  children,
  size,
  adaptive,
  centered,
  footer = false,
  footerTools,
  footerButtonOk,
  footerConfirmButton,
  disabledConfirmButton = false,
  onConfirm,
  footerCloseButton = false,
  confirmButtonText,
  ConfirmButtonIcone,
  footerConfirmButtonInvert,
  cancelButtonText,
  onCancel,
  dialogClassName,
  zIndex,
}: ModalProps) {
  return (
    <>
      {adaptive && <AdaptiveModalGlobalStyle />}
      {zIndex && <StackedBackdropStyle $zIndex={zIndex} />}
      <Modal
        onHide={handleClose}
        show={show}
        size={adaptive ? undefined : size}
        dialogClassName={adaptive ? "modal-adaptive" : dialogClassName}
        aria-labelledby="contained-modal-title-vcenter"
        centered={centered}
        style={zIndex ? { zIndex } : undefined}
        backdropClassName={zIndex ? `modal-backdrop--z${zIndex}` : undefined}
      >
        {title && (
          <Header>
            <Title>{title}</Title>
            <ButtonClose onClick={handleClose}>
              <FontAwesomeIcon icon={faXmark} />
            </ButtonClose>
          </Header>
        )}
        <ModalBody>
          {subTitle && <p>{subTitle}</p>}
          {children}
        </ModalBody>
        {footer && (
          <Footer>
            {footerButtonOk && (
              <PrimaryButton onClick={handleClose}>OK</PrimaryButton>
            )}

            {footerConfirmButton && (
              <>
                <ModalButton
                  onClick={onCancel ?? handleClose}
                  outline={true}
                  variante="primary"
                >
                  {cancelButtonText || "Cancelar"}
                </ModalButton>
                <ModalButton
                  type="submit"
                  onClick={onConfirm}
                  disabled={disabledConfirmButton}
                >
                  {confirmButtonText || "Confirmar"}
                  {ConfirmButtonIcone}
                </ModalButton>
              </>
            )}

            {footerConfirmButtonInvert && (
              <>
                <ModalButton
                  type="submit"
                  onClick={onConfirm}
                  disabled={disabledConfirmButton}
                >
                  {confirmButtonText || "Confirmar"}
                  {ConfirmButtonIcone}
                </ModalButton>
                <ModalButton
                  onClick={handleClose}
                  outline={true}
                  variante="primary"
                >
                  Cancelar
                </ModalButton>
              </>
            )}

            {footerCloseButton && (
              <ModalButton
                onClick={handleClose}
                outline={true}
                variante="primary"
              >
                Fechar
              </ModalButton>
            )}

            {footerTools}
          </Footer>
        )}
      </Modal>
    </>
  );
}
